export { TranscriptComponent } from "./transcript-component";
export type { TranscriptComponentProps } from "./transcript-component";
